import {Attachment} from '@/repositories/beneva-api/endpoints/attachments';
import {DocumentAttachments} from '@/types/document/store';

export const mapDocumentAttachments = (attachments: Attachment[]): DocumentAttachments => {
  return attachments.reduce<DocumentAttachments>((acc, attachment) => {
    const [, sectionId] = Array.from(attachment.fieldId.match(/^([A-Z]+)(\d+)$/) ?? []);

    if (sectionId && attachment.id) {
      const section = acc[sectionId] ?? {fields: {}};

      return {
        ...acc,
        [sectionId]: {
          fields: {...section.fields, [attachment.fieldId]: attachment.id},
        },
      };
    }

    return acc;
  }, {});
};

export const getAllAttachmentIds = (attachments: DocumentAttachments): string[] => {
  return Object.values(attachments).flatMap(({fields}) => Object.values(fields));
};

export const getSectionAttachmentIds = (attachments: DocumentAttachments, section: string) => {
  if (!attachments[section]) {
    return [];
  }

  return Object.values(attachments[section].fields);
};
